import React from 'react'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'

const HoverInfo = ({ node }) => {
  const dateParser = aDate => {
    const parsedDate = Date.parse(aDate)
    return format(parsedDate, 'dd MMMM yyyy', { locale: es })
  }

  const {
    comuna,
    delitos,
    estadoDeLaCausa,
    fecha,
    formalizados,
    latitud,
    longitud,
    polic_aACargo,
    regi_n,
    rit,
    ruc,
    sector,
    semester,
    tribunal,
    year,
  } = node
  return (
    <div className="p-2 bg-white rounded shadow-md font-inter">
      <header>
        <h4 className="text-xl leading-none text-grisnegro">
          {delitos}
          <small className="block text-sm text-grisclaro">
            {dateParser(fecha)}
          </small>
          <small className="block text-sm text-grisclaro">{rit}</small>
          <small className="block text-sm text-grisclaro">{ruc}</small>
          <small className="block text-sm text-grisnegro ">
            {comuna}, {regi_n}
          </small>
          <small className="block text-sm text-grisclaro">{sector}</small>
        </h4>
      </header>

      <p></p>
      {}
    </div>
  )
}

export default HoverInfo
